import { Grid, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";

export const SummaryConditionsRow = ({ title, value }) => {
  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  return (
    <Grid container justifyContent="space-between">
      <Grid container item xs={8} justifyContent="flex-start">
        <Typography variant={isScreenXs ? "subtitle2" : "subtitle2"}>
          {title}
        </Typography>
      </Grid>
      <Grid container item xs={4} justifyContent="flex-end">
        <Typography variant={isScreenXs ? "subtitle2" : "subtitle2"}>
          <strong>{value}</strong>
        </Typography>
      </Grid>
    </Grid>
  );
};
